'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import BrandLogo from '@/fo/icons/base/icons/logo.svg';
import { getClearPhoneNumber } from '@/fo/util/format-phone-number';
import { CustomVariablesData } from '@/fo/util/map-custom-variable-data';

import { styles } from './UiAppFooterCheckout.styles';

export interface UiAppFooterCheckoutProps {
  customVariables?: CustomVariablesData;
}

export function UiAppFooterCheckout({
  customVariables
}: UiAppFooterCheckoutProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <footer className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.left()}>
          <Link
            href={'/'}
            className={slots.logo()}
          >
            <BrandLogo className={slots.logoIcon()} />
          </Link>

          {customVariables?.copyright && (
            <div className={slots.text()}>{customVariables.copyright}</div>
          )}
        </div>

        <div className={slots.right()}>
          <div className={slots.column()}>
            {customVariables?.authorized_store_title && (
              <div className={slots.title()}>
                {customVariables.authorized_store_title}
              </div>
            )}

            <div className="flex flex-col">
              {customVariables?.authorized_store_address && (
                <div className={slots.text()}>
                  {`${t('Address')}: ${customVariables.authorized_store_address}`}
                </div>
              )}

              {customVariables?.authorized_store_phone && (
                <div className={slots.text()}>
                  {`${t('phone')}: `}
                  <Link
                    href={`tel:${getClearPhoneNumber(customVariables.authorized_store_phone)}`}
                    className={slots.link()}
                  >
                    {customVariables.authorized_store_phone}
                  </Link>
                </div>
              )}

              {customVariables?.authorized_store_opening_hours && (
                <div className={slots.text()}>
                  {customVariables.authorized_store_opening_hours}
                </div>
              )}
            </div>
          </div>

          <div className={slots.column()}>
            <div className={slots.title()}>{t('Contact center')}</div>

            <div className="flex flex-col">
              {customVariables?.phone && (
                <Link
                  href={`tel:${getClearPhoneNumber(customVariables.phone)}`}
                  className={slots.link()}
                >
                  {customVariables.phone}
                </Link>
              )}

              {customVariables?.opening_hours && (
                <div className={slots.text()}>
                  {customVariables.opening_hours}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
